import { RotatingLines } from "react-loader-spinner";

export default function Loader() {
  return (
    <div className="fixed top-0 left-0 h-screen w-screen bg-primary-gradient ">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        <RotatingLines
          visible={true}
          width="120"
          strokeWidth="5"
          animationDuration="0.75"
          ariaLabel="rotating-lines-loading"
          strokeColor="#ffffff"
        />
      </div>
    </div>
  );
}
